exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".guify-button {\n  box-sizing: border-box !important;\n  color: #a1a1a1;\n  background-color: #363636; }\n\n.guify-button:hover {\n  color: #a1a1a1;\n  background-color: #3a3a3a; }\n\n.guify-button:active {\n  color: #363636;\n  background-color: #a1a1a1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/components/button.scss
// module id = 37
// module chunks = 0